export function beforeRegistration ({ Vue, config, store, isServer }) {
  // No local storage required — NetSuite data is fetched on demand.
}
